module.exports = __webpack_public_path__ + "fonts/471a7971/proximanova-regularit-webfont.eot";